export function MFCheckbox({
  value,
  label,
  checked,
  onChange,
  className,
  marginBottom,
}) {
  return (
    <label
      className={`d-flex align-items-center ${className || ""}`}
      style={{
        fontSize: 15,
        width: "fit-content",
        cursor: "pointer",
        marginBottom: marginBottom || 0,
      }}
    >
      <div
        className="d-flex align-items-center"
        style={{ width: 20, height: 20, marginRight: label ? 6 : 0 }}
      >
        <input
          checked={checked}
          onChange={onChange}
          type="checkbox"
          value={value}
          className="checkbox-primary"
        />
      </div>
      {label}
    </label>
  );
}
